import {priority} from '@priority-software/priority-proto-api/lib';
import {ColumnsFieldsNames, ReportColumn} from '../types';
import {dateColumnTypes} from './FieldsTable/consts';
import {Report} from '../stores/ReportStore';
import texts from '../texts';

export const fieldTableValidation = (currentReport: Report): string => {
    const {columns, setColumns} = currentReport;

    const errorTypes = [];
    const validatedColumns: ReportColumn[] = columns.map(col => {
        const errors = validateColumn(col);
        errorTypes.push(...errors);

        return {...col, error: errors?.length ? errors : null};
    });
    setColumns(validatedColumns);

    const generalError = generalValidation(columns);
    if (generalError) {
        return generalError;
    }

    return buildErrorMessage(errorTypes);
};

export const validateSortValue = (currentReport: Report): void => {
    /* EP-47788 In case a date-type field has “X axis field”,
        AND     no sort was selected for it, 
        we should set the sort value to be the highest. */
    const {columns, updateColumn} = currentReport;
    const xAxisDateFieldIndex = columns?.findIndex(
        col =>
            col.AxisMode === priority.netitems.nrest.RepColAxisMode.RepColAxisMode_X &&
            dateColumnTypes.includes(col.Type)
    );
    if (columns[xAxisDateFieldIndex]?.Sort === 0) {
        const reportSortValues = columns.map(col => col.Sort).sort();
        const highestSortValue = reportSortValues[reportSortValues.length - 1] || 0;
        updateColumn(xAxisDateFieldIndex, ColumnsFieldsNames.Sort, Number(highestSortValue) + 1);
    }
};

const validateColumn = (column: ReportColumn): ColumnsFieldsNames[] => {
    const {Expr, Width} = column;

    const col = {...column};
    const errors: ColumnsFieldsNames[] = [];

    if (col.IsExpression && !Expr) {
        errors.push(ColumnsFieldsNames.Expr);
    }

    if (!Number(Width)) {
        errors.push(ColumnsFieldsNames.Width);
    }

    return errors;
};

const generalValidation = (columns: ReportColumn[]) => {
    if (columns.length === 1 && columns[0].IsCompany) {
        return texts.onlyCompFieldError;
    }
    return null;
};

const buildErrorMessage = (errors: ColumnsFieldsNames[]): string => {
    const uniqueErrorsType = new Set(errors);
    if (
        uniqueErrorsType.has(ColumnsFieldsNames.Expr) &&
        uniqueErrorsType.has(ColumnsFieldsNames.Width)
    ) {
        return texts.validationMsgWidthAndExpr;
    }

    if (uniqueErrorsType.has(ColumnsFieldsNames.Expr)) {
        return texts.validationMsgExpr;
    }

    if (uniqueErrorsType.has(ColumnsFieldsNames.Width)) {
        return texts.validationMsgWidth;
    }

    return null;
};
